import { 
  CONFIRMED_GET_PATIENT_CURED_DISEASES,
  CONFIRMED_UPDATE_PATIENT_CURED_DISEASES
} from "../actions/PatientCuredDiseasesTypes";

const initialState = {
  curedDiseases: [], // Array of disease IDs that are cured
};

export default function PatientCuredDiseasesReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case CONFIRMED_GET_PATIENT_CURED_DISEASES:
      return {
        ...state,
        curedDiseases: action.payload || [],
      };

    case CONFIRMED_UPDATE_PATIENT_CURED_DISEASES:
      return {
        ...state,
        curedDiseases: action.payload || [],
      };

    default:
      return state;
  }
}
